import { FC, SVGProps } from 'react'

export const AICheckIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    {...props}
  >
    <path
      d="M1 6.83333L5.11765 11L15 1"
      stroke="url(#paint0_linear_624_1622)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_624_1622"
        x1="1"
        y1="6"
        x2="15"
        y2="6"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79F9FB" />
        <stop offset="1" stopColor="#90FEAD" />
      </linearGradient>
    </defs>
  </svg>
)
